<template>
  <div>
    <div class="layout-content">
      <div class="left">
        <div class="logo">
          <a href="https://www.infoq.cn/zones/fintechathon/campus2022">
            <img class="logo-img" src="https://static001.geekbang.org/resource/image/5e/ee/5e1be909bac86b0bdde9c0805ce1acee.png">
          </a>
        </div>
        <ul class="nav">
          <!-- && item.hash === $route.hash -->
          <li
            v-for="(item, index) in navData"
            class="nav-li"
            :class="[
              { active: item.id === $route.meta.id },
              { hoverBox: item.children && item.children.length }
            ]"
            :key="index"
            @click="changeNavTab(item)"
            @mouseenter="mouseenterHandler(item)"
            @mouseleave="mouseleaveHandler(item)"
          >
            <span>{{ item.title }}</span>

            <transition name="gk-slide-in">
              <div v-if="showChildrenMemory[item.id]" class="routerBox">
                <p
                  v-for="(each) in item.children"
                  :key="each.id"
                  @click="changeNavTab(each)"
                >
                  {{ each.title }}
                </p>
              </div>
            </transition>
          </li>
          <!-- <li class="join-btn"><span class="lx"></span><span>立即参赛</span></li> -->
        </ul>
      </div>

      <div class="right">
        <!-- <div class="lang">
          <span :class="isEn ? 'active': ''" @click="setLang('zh-CN')">中文</span>
          <span class="line">/</span>
          <span @click="setLang('en-US')" :class="!isEn ? 'active': ''">EN</span>
        </div> -->
        <!-- <a href="https://www.infoq.cn/form/?id=1139" target="_blank"> -->
        <a href="/zones/fintechathon/campus2022/result" target="_blank">
          <div class="button">
            <!-- 立即报名 -->
            <!-- 入围名单 -->
            结果公布
          </div>
        </a>
      </div>
    </div>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: ['navData', 'index', 'top'],
  data () {
    return {
      showMobileMenu: false,
      scrollTop: 0,
      ready: false,
      slideActive: Number(this.$route.query.tab),
      activeId: -1,

      showChildrenMemory: {}
    }
  },
  computed: {
    ...mapState(['lang', 'isEnLang']),
    isEn () {
      return this.lang === 'zh-CN'
    },
    registerImg () {
      return this.isEnLang ? require('../../../assets/img/en/sign_up.png') : 'https://static001.geekbang.org/resource/image/20/73/208abdf91b0ec3a336a1f6c3edd69c73.png'
    }
  },
  created () {
    this.activeId = this.$route.meta.id
  },
  methods: {
    ...mapActions([
      'setLang'
    ]),

    changeNavTab (item) {
      this.$emit('changeNav', item)
    },

    mouseleaveHandler (item) {
      if (item.children && item.children.length) {
        this.$set(this.showChildrenMemory, item.id, false)
      }
    },

    mouseenterHandler (item) {
      if (item.children && item.children.length) {
        this.$set(this.showChildrenMemory, item.id, true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.layout-content {
  display: flex; align-items: center; justify-content: space-between;
  height: 80px;

  .left {
    display: flex; align-items: center;
  }

  .right {
    display: flex; align-items: center;
  }

  .logo {
    width: 300px;
    margin-right: 148px;

    .logo-img {
      width: 300px; height: 32px;
    }
  }

  .nav {
    display: flex; align-items: center;
    font-size: 17px;
    // color: #fff;
    // margin-left: 32px;
    font-weight: 400;

    .nav-li {
      position: relative;
      display: flex; align-items: center;
      height: 80px;
      padding: 12px 0;
      margin-right: 50px;
      line-height: 1;
      @extend %transition;

      & span:hover {
        color: #000000;
        font-weight: 600;
        cursor: pointer;

        @include enlayoutInner {
          font-weight: 400;
        }
      }

      &.active {
        color: #000000;
        font-weight: 600;

        &::after {
          content: "";
          position: absolute; top: 60px; left: 20px;
          width: 30px; height: 5px;
          background: #DE3640;
        }

        @include enlayoutInner {
          font-weight: 400;
        }
      }
    }
  }

  .lang {
    margin-right: 50px;
    font-size: 18px;
    color: #FFF;

    & span {
      cursor: pointer;
    }

    & .line {
      margin: 0 10px;
    }
  }

  .active {
    color: #FF0054;
  }

  .button {
    width: 122px; height: 44px;
    line-height: 46px;
    text-align: center;
    background: #DA3A3E;
    cursor: pointer;
    font-size: 18px;
    color: #FFFFFF;
    // background: linear-gradient(-30deg,rgba(255,0,84,1),rgba(43,112,251,1));
    position: relative;
    &:hover {
      background: #CB232D;
    }
    img {
      position: absolute; z-index: 1;
      width: 100%;
    }
    .hover {
      // position: absolute; top: 20px; left: 20px; right: 20px; bottom: 20px;
      // @extend %transition;
      transition: all linear 0.3s;
    }
  }
}

.hoverBox {
  position: relative;

  & .routerBox {
    position: absolute; top: calc(100% + 0px); left: 50%; z-index: 1;
    min-width: 150px;
    margin-left: -75px; padding: 12px 0;
    text-align: center;
    border: 1px solid #D8D8D8;
    background: rgba(#fff, 1);
    box-shadow: 0px 3px 24px 0px rgba(0,0,0,0.0600);
    font-size: 14px;
    color: #818B91;

    & p {
      height: 54px;
      margin: 0 12px;
      font-size: 16px; font-weight: 400;
      color: #000000;
      line-height: 54px;
      cursor: pointer;

      &:hover {
        background: #F3F7FB;
      }
    }
  }

  &:last-child {
    .routerBox {
      min-width: 230px;
      margin-left: -110px;
    }
  }
}

</style>
